import type { AgentSessionEngineStateBase } from "./types.ts";

const EMPTY_ENGINE_AVAILABLE_COMMANDS: never[] = [];

export function selectEngineAvailableCommands(
  state: AgentSessionEngineStateBase,
  agentSessionId: string | null | undefined
) {
  const id = agentSessionId?.trim() ?? "";
  const entry = state.sessionCommands.bySessionId[id];
  const session = state.sessionLifecycle.sessionsById[id];
  return entry && session?.workspaceId === entry.workspaceId
    ? entry.commands
    : EMPTY_ENGINE_AVAILABLE_COMMANDS;
}
